import React from 'react';
import { FormGroup, Label, Input, InputGroup, InputGroupText, FormFeedback } from 'reactstrap';

// Tutarın başında gösterilen para birimi göstergesi. Sabit tutarlı linkte para birimi
// seçimi gizlendiği için tek gösterge budur; serbest tutarda seçimle birlikte güncellenir.
const CURRENCY_PREFIX = { TL: 'TL', TRY: 'TL', USD: '$', EUR: 'EUR', GBP: 'GBP' };

const PaymentAmountInput = ({
                                displayAmount,
                                onAmountChange,
                                selectedCurrency,
                                onCurrencyChange,
                                readOnly,
                                formikErrorTouched // { error, touched }
                            }) => (
    <FormGroup className="mb-3">
        <Label>Ödeme Tutarı</Label>
        <InputGroup>
            <InputGroupText className="fw-semibold">
                {CURRENCY_PREFIX[selectedCurrency] || CURRENCY_PREFIX.TL}
            </InputGroupText>
            <Input
                type="text"
                inputMode="decimal"
                className="form-control form-control-lg"
                placeholder="0,00"
                value={displayAmount}
                onChange={onAmountChange}
                invalid={formikErrorTouched?.touched && !!formikErrorTouched?.error}
                readOnly={readOnly}
            />
            {!readOnly && (
                <InputGroupText>
                    <Input
                        type="select"
                        value={selectedCurrency}
                        onChange={onCurrencyChange}
                        style={{ border: 'none', background: 'transparent' }}
                    >
                        <option value="TL">TL</option>
                        <option value="USD">USD</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                    </Input>
                </InputGroupText>
            )}
        </InputGroup>
        {formikErrorTouched?.touched && formikErrorTouched?.error && (
            <FormFeedback>{formikErrorTouched.error}</FormFeedback>
        )}
    </FormGroup>
);

export default PaymentAmountInput;
